export default __webpack_public_path__ + "static/media/swipe_divider_with_texture.8d503d8c.png";